import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import { getToken,setToken,removeToken } from '@/utils/auth.js'
import store from '@/store/index.js'
import router from '@/router/index.js'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 30000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  conf => {
    conf.headers['token'] = getToken();
    if(process.env.NODE_ENV!='production') console.log(zyl.parse_time(new Date())+' '+conf.baseURL+conf.url+" param",JSON.stringify(conf.data));
    return conf
  },
  error => {return Promise.reject(error)}
)

// response interceptor
service.interceptors.response.use(
  response => {
    if(process.env.NODE_ENV!='production') console.log(zyl.parse_time(new Date())+' '+response.request.responseURL+" response",response.data);
    const code = response.status
    if (code < 200 || code > 300) {
      Notification.error({ title: response.message })
      return Promise.reject('error')
    } else {
        // console.log('response',response)
      if (response.headers['content-type'] === 'application/octet-stream;charset=UTF-8') {
        if (!response.data) { return } 
        // console.log('dis',response)
        const link = document.createElement('a') 
        link.style.display = 'none' 
        link.href = window.URL.createObjectURL(new Blob([response.data], { type: 'application/octet-stream;charset=UTF-8' }))  
        link.setAttribute('download', decodeURIComponent(response.headers["content-disposition"].split('=')[1])) 
        document.body.appendChild(link) 
        link.click() 
        document.body.removeChild(link) 
        return 
      }

      if(response.data.code=="101"){
        store.dispatch('logout', {}).then(() => {})
        router.push({path:'/login'})
      }
      if(response.data.code!=200){
        Message({ message: response.data.text, type: 'error', duration: 5 * 1000 });
      }

      const user_ip = document.getElementsByClassName('user_ip');
      if(response.headers.token!=undefined) setToken(response.headers.token);
      if(response.headers.time!=undefined) localStorage.setItem('server_time',response.headers.time)
      if(response.headers.client_ip!=undefined&&user_ip.length>0) user_ip[0].textContent = response.headers.client_ip;
      return response.data
    }
  },
  error => {
    // console.log('err' + error) // for debug
    Message({ message: error.message, type: 'error', duration: 5 * 1000 })
    return Promise.reject(error)
  }
)

export default service
